<h3 class="text-light-gray pt-lg-peta pt-giga">{{header}}</h3>
<div class="pt-lg-kilo pt-hecto">
  <ng-content></ng-content>
</div>
